export enum CERFAT_ROUTES {
  GET_ALL = "/cerfat",
  GET_ONE = "/cerfat/",
  CREATE = "/cerfat",
  UPDATE = "/cerfat/",
  GENERATE_DOCUMENT = "/cerfat/generate-pdf/",
  GENERATE_DOCUMENTS = "/cerfat/generate-pdfs/",
}
